import * as Color from "color"
import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default class TableFormPart extends React.Component<Props, State> {
	private readonly defaultTableHeaderBackgroundColor = "#15b2bf"
	private readonly defaultTableTextColor = "#474747"
	private readonly defaultTableBorderColor = this
	.GetBorderColor(this.defaultTableHeaderBackgroundColor)
	private readonly defaultTableHeaderTextColor = this
	.GetHeaderTextColor(this.defaultTableHeaderBackgroundColor)
	private readonly defaultTableSubtotalBackgroundColor = this
	.GetSubtotalBackgroundColor(this.defaultTableHeaderBackgroundColor)
	private readonly defaultTableSubtotalTextColor = this
	.GetSubtotalTextColor(Color(this.defaultTableHeaderBackgroundColor))

	constructor(props: Readonly<Props>) {
		super(props)
		this.state = {
			tableBorderColor: this.defaultTableBorderColor,
			tableHeaderBackgroundColor: this.defaultTableHeaderBackgroundColor,
			tableHeaderTextColor: this.defaultTableHeaderTextColor,
			tableSubtotalBackgroundColor: this.defaultTableSubtotalBackgroundColor,
			tableSubtotalTextColor: this.defaultTableSubtotalTextColor,
			tableTextColor: this.defaultTableTextColor
		}
	}

	render() {
		const tableCellStyle: React.CSSProperties = {
			color: this.state.tableTextColor,
			borderColor: this.state.tableBorderColor,
			fontFamily: "Calibri, sans-serif",
			fontSize: "8pt",
			padding: `${0.1 as number * 72}px`
		}

		const tableHeaderStyle: React.CSSProperties = {
			...tableCellStyle,
			backgroundColor: this.state.tableHeaderBackgroundColor,
			color: this.state.tableHeaderTextColor,
			fontWeight: "bold"
		}

		const tableSubtotalStyle: React.CSSProperties = {
			...tableHeaderStyle,
			backgroundColor: this.state.tableSubtotalBackgroundColor,
			color: this.state.tableSubtotalTextColor
		}

		const TableColorConfigurations: TableColorConfiguration[] = [
			{
				buttonName: Names.ResetColorTableHeaderBackground,
				inputName: Names.TableHeaderBackgroundColor,
				inputValue: this.state.tableHeaderBackgroundColor,
				label: "Couleur de fond des en-têtes et pieds de tableaux"
			},
			{
				buttonName: Names.ResetColorTableHeaderText,
				inputName: Names.TableHeaderTextColor,
				inputValue: this.state.tableHeaderTextColor,
				label: "Couleur de texte des en-têtes et pieds de tableaux"
			},
			{
				buttonName: Names.ResetColorTableBorder,
				inputName: Names.TableBorderColor,
				inputValue: this.state.tableBorderColor,
				label: "Couleur de bordure des tableaux"
			},
			{
				buttonName: Names.ResetColorTableText,
				inputName: Names.TableTextColor,
				inputValue: this.state.tableTextColor,
				label: "Couleur de texte des lignes de tableaux"
			},
			{
				hidden: true,
				inputName: Names.TableSubtotalBackgroundColor,
				inputValue: this.state.tableSubtotalBackgroundColor
			},
			{
				hidden: true,
				inputName: Names.TableSubtotalTextColor,
				inputValue: this.state.tableSubtotalTextColor
			}
		]

		return <section className="section">
			<h2 className="title">Personnalisation des tableaux</h2>

			{TableColorConfigurations.map((conf, i) => isHiddenConfiguration(conf)
			? <input key={i} name={conf.inputName} type="hidden" value={conf.inputValue} />
			: <div className="field" key={i}>
				<label className="checkbox">
					<input
					className="button"
					name={conf.inputName}
					onChange={e => this.handleChangeColor(e)}
					style={{ verticalAlign: "middle" }}
					type="color"
					value={conf.inputValue} />&nbsp;

					<button
					className="button"
					name={conf.buttonName}
					onClick={e => this.handleResetColor(e)}
					style={{ verticalAlign: "middle" }}
					title="Couleur par défaut"
					type="button">
						<FontAwesomeIcon icon="undo" />
					</button>&nbsp;

					{conf.label}
				</label>
			</div>)}

			<table className="table is-bordered">
				<thead>
					<tr>
						<th style={tableHeaderStyle}>En-tête col 1</th>
						<th style={tableHeaderStyle}>En-tête col 2</th>
						<th style={tableHeaderStyle}>En-tête col 3</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td style={tableCellStyle}>Ligne 1 col 1</td>
						<td style={tableCellStyle}>Ligne 1 col 2</td>
						<td style={tableCellStyle}>Ligne 1 col 3</td>
					</tr>
					<tr>
						<td style={tableCellStyle}>Ligne 2 col 1</td>
						<td style={tableCellStyle}>Ligne 2 col 2</td>
						<td style={tableCellStyle}>Ligne 2 col 3</td>
					</tr>
					<tr>
						<td style={tableCellStyle}>Ligne 3 col 1</td>
						<td style={tableCellStyle}>Ligne 3 col 2</td>
						<td style={tableCellStyle}>Ligne 3 col 3</td>
					</tr>
					<tr>
						<td style={tableSubtotalStyle}>Ligne sous-total 1 col 1</td>
						<td style={tableSubtotalStyle}>Ligne sous-total 1 col 2</td>
						<td style={tableSubtotalStyle}>Ligne sous-total 1 col 3</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<th style={tableHeaderStyle}>Pied col 1</th>
						<th style={tableHeaderStyle}>Pied col 2</th>
						<th style={tableHeaderStyle}>Pied col 3</th>
					</tr>
				</tfoot>
			</table>
		</section>
	}

	private GetBorderColor(color: Color): string
	private GetBorderColor(color: string): string
	private GetBorderColor(color: Color | string): string {
		return Color(color).mix(Color("black"), 0.5).hex()
	}

	private GetHeaderTextColor(color: Color): string
	private GetHeaderTextColor(color: string): string
	private GetHeaderTextColor(color: Color | string): string {
		if ("string" === typeof color) color = Color(color)
		return color.isLight()
			? Color(color).mix(Color("black"), 0.75).hex()
			: Color(color).mix(Color("white"), 0.9).hex()
	}

	private GetSubtotalBackgroundColor(color: Color): string
	private GetSubtotalBackgroundColor(color: string): string
	private GetSubtotalBackgroundColor(color: Color | string): string {
		return Color(color).mix(Color("white"), 0.75).hex()
	}

	private GetSubtotalTextColor(color: Color): string
	private GetSubtotalTextColor(color: string): string
	private GetSubtotalTextColor(color: Color | string): string {
		if ("string" === typeof color) color = Color(color)
		return color.isLight()
			? Color(color).mix(Color("black"), 0.75).hex()
			: Color(color).mix(Color("white"), 0.9).hex()
	}

	private handleChangeColor(e: React.SyntheticEvent<Element>): void {
		const input = e.currentTarget as HTMLInputElement

		switch (input.name) {
			case Names.TableHeaderBackgroundColor:
				const inputColor = Color(input.value)
				const tableHeaderTextColor: string = this.GetHeaderTextColor(inputColor)
				const tableBorderColor: string = this.GetBorderColor(inputColor)
				const tableSubtotalBackgroundColor: string = this
				.GetSubtotalBackgroundColor(inputColor)
				const tableSubtotalTextColor: string = this
				.GetSubtotalTextColor(tableSubtotalBackgroundColor)

				this.setState({
					tableHeaderBackgroundColor: input.value,
					tableHeaderTextColor,
					tableBorderColor,
					tableSubtotalBackgroundColor,
					tableSubtotalTextColor
				})
				break
			case Names.TableHeaderTextColor:
				this.setState({ tableHeaderTextColor: input.value })
				break
			case Names.TableBorderColor:
				this.setState({ tableBorderColor: input.value })
				break
			case Names.TableTextColor:
				this.setState({ tableTextColor: input.value })
				break
		}
	}

	private handleResetColor(e: React.MouseEvent<Element>): void {
		const button = e.currentTarget as HTMLButtonElement

		switch (button.name) {
			case Names.ResetColorTableBorder:
				this.setState({ tableBorderColor: this.defaultTableBorderColor })
				break
			case Names.ResetColorTableHeaderBackground:
				this.setState({
					tableHeaderBackgroundColor: this.defaultTableHeaderBackgroundColor
				})
				break
			case Names.ResetColorTableHeaderText:
				this.setState({
					tableHeaderTextColor: this.defaultTableHeaderTextColor
				})
				break
			case Names.ResetColorTableText:
				this.setState({ tableTextColor: this.defaultTableTextColor })
				break
		}
	}
}

export const Names = {
	ResetColorTableBorder: "generalities-reset-color-table-border",
	ResetColorTableHeaderBackground: "generalities-reset-color-table-header-background",
	ResetColorTableHeaderText: "generalities-reset-color-table-header-text",
	ResetColorTableHighlightBackground: "generalities-reset-color-table-highlight-background",
	ResetColorTableHighlightText: "generalities-reset-color-table-highlight-text",
	ResetColorTableText: "generalities-reset-color-table-text",
	TableBorderColor: "generalities-table-border-color",
	TableHeaderBackgroundColor: "generalities-table-header-background-color",
	TableHeaderTextColor: "generalities-table-header-text-color",
	TableSubtotalBackgroundColor: "generalities-table-subtotal-background-color",
	TableSubtotalTextColor: "generalities-table-subtotal-text-color",
	TableTextColor: "generalities-table-text-color"
}

export interface Props {}

function isHiddenConfiguration(
	conf: TableColorConfiguration
): conf is HiddenColorConfiguration {
	return undefined !== (conf as HiddenColorConfiguration).hidden
}

interface BaseColorConfiguration {
	inputName: string
	inputValue: string
}

interface ColorConfiguration extends BaseColorConfiguration {
	buttonName: string
	label: string
}

interface HiddenColorConfiguration extends BaseColorConfiguration {
	hidden: boolean
}

interface State {
	tableBorderColor: string
	tableHeaderBackgroundColor: string
	tableHeaderTextColor: string
	// tableHighlightBackgroundColor: string
	// tableHighlightTextColor: string
	tableSubtotalBackgroundColor: string
	tableSubtotalTextColor: string
	tableTextColor: string
}

type TableColorConfiguration = HiddenColorConfiguration | ColorConfiguration



// WEBPACK FOOTER //
// ./src/component/management-report/form-parts/table-form-part/index.tsx